import React, { useRef, useEffect, useState, useMemo, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

function DashboardTabs({ activeTab, onTabChange }) {
    const navigate = useNavigate();
    const tabsRef = useRef([]);
    const [tabIndicatorStyle, setTabIndicatorStyle] = useState({});

    const tabs = useMemo(() => [
        { id: 'projects', label: 'Projects', shortLabel: ['Projects'] },
        { id: 'weekly-planner', label: 'Weekly Planner', shortLabel: ['Weekly', 'Planner'] },
        { id: 'recurring-tasks', label: 'Recurring Tasks', shortLabel: ['Recurring', 'Tasks'] },
        { id: 'timeblock', label: 'Timeblock', shortLabel: ['Timeblock'] }
    ], []);

    const updateTabIndicator = useCallback(() => {
        const activeTabIndex = tabs.findIndex(tab => tab.id === activeTab);
        const activeTabElement = tabsRef.current[activeTabIndex];
        if (activeTabElement) {
            setTabIndicatorStyle({
                left: `${activeTabElement.offsetLeft}px`,
                width: `${activeTabElement.offsetWidth}px`,
            });
        }
    }, [activeTab, tabs]);

    useEffect(() => {
        updateTabIndicator();
        
        // Add resize event listener
        window.addEventListener('resize', updateTabIndicator);
        
        // Cleanup function to remove event listener
        return () => {
            window.removeEventListener('resize', updateTabIndicator);
        };
    }, [updateTabIndicator]);

    const handleTabClick = useCallback((tabId) => {
        if (tabId === 'projects') {
            navigate('/projects');
        } else if (tabId === 'timeblock') {
            navigate('/timeblock');
        }
        onTabChange(tabId);
    }, [navigate, onTabChange]);

    return (
        <div className="relative border-b border-[var(--surface-border)] mb-4">
            <div className="flex">
                {tabs.map((tab, index) => (
                    <button
                        key={tab.id}
                        ref={(el) => (tabsRef.current[index] = el)}
                        onClick={() => handleTabClick(tab.id)}
                        className={`flex-1 text-center py-2 px-1 sm:px-4 text-xs sm:text-sm font-medium flash-button ${
                            activeTab === tab.id ? 'text-[var(--primary-button)]' : 'text-[var(--text-muted)]'
                        } focus:outline-none`}
                    >
                        <span className="sm:hidden flex flex-col leading-tight">
                            {tab.shortLabel.map((word, i) => <span key={i}>{word}</span>)}
                        </span>
                        <span className="hidden sm:inline">{tab.label}</span>
                    </button>
                ))}
            </div>
            <div
                className="absolute bottom-0 left-0 h-0.5 bg-[var(--primary-button)] transition-all duration-300"
                style={tabIndicatorStyle}
            />
        </div>
    );
}

export default DashboardTabs; 